import { createFileRoute } from '@tanstack/react-router'
import LegalPage from '../landing/LegalPage'

export const Route = createFileRoute('/terms')({
  component: RouteComponent,
})

function RouteComponent() {
  return <LegalPage />
}
